import React, { FunctionComponent } from 'react';

import { SvgProps, propsHelperRem } from '@/shared/lib/propsHelper';

const Check: FunctionComponent<SvgProps> = (props) => (
    <svg {...propsHelperRem(2.4, 2.4, props)}>
        <path d="m22.09 6.354-12 11.75-.85.83-.839-.84-6.5-6.5 1.697-1.696 5.66 5.66L20.41 4.638l1.68 1.716Z" />
    </svg>
);

export default Check;
